import Vue from 'vue'

export default {

  state: Vue.observable({
    products: [],
  }),
  
  setProducts(products) {
    this.state.products = products
  },

  updateProduct(newProduct) {
    this.state.products = this.state.products.map(product => {
      return product.id == newProduct.id ? newProduct : product
    })
  },
}
